import axios from 'axios'

export default axios.create({
    baseURL: 'https://react-quiz-70ed1.firebaseio.com/'
})